export type Period = 'AM' | 'PM';

export interface ParsedTime {
  hour12: number; // 1–12
  minute: number; // 0–59
  period: Period;
}

export function parse(value: string): ParsedTime | null {
  const match = /^(\d{1,2}):(\d{2})$/.exec(value);
  if (!match) return null;
  const hour24 = Number(match[1]);
  const minute = Number(match[2]);
  if (
    !Number.isFinite(hour24) ||
    !Number.isFinite(minute) ||
    hour24 < 0 ||
    hour24 > 23 ||
    minute < 0 ||
    minute > 59
  ) {
    return null;
  }
  const period: Period = hour24 >= 12 ? 'PM' : 'AM';
  const hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;
  return { hour12, minute, period };
}

export function pad(n: number): string {
  return n.toString().padStart(2, '0');
}

export function compose(
  hour12: number,
  minute: number,
  period: Period,
): string {
  let hour24: number;
  if (period === 'AM') {
    hour24 = hour12 === 12 ? 0 : hour12;
  } else {
    hour24 = hour12 === 12 ? 12 : hour12 + 12;
  }
  return `${pad(hour24)}:${pad(minute)}`;
}

export const HOURS = Array.from({ length: 12 }, (_, i) => i + 1); // 1..12

/** 5-minute granularity used by the picker UI. */
export const MINUTES_5 = Array.from({ length: 12 }, (_, i) => i * 5); // 0,5,...,55

/** Index into MINUTES_5 nearest to an arbitrary minute (0..59). */
export function closestMinuteIndex(minute: number): number {
  if (!Number.isFinite(minute) || minute < 0) return 0;
  if (minute >= 55) return MINUTES_5.length - 1;
  return Math.round(minute / 5);
}
